import React from 'react';
import PageShell from '../Components/ui/PageShell';
import RecruiterTodayWork from '../Components/ui/RecruiterTodayWork';
import { getDecryptedData } from '../utils/authStorage';

function RecruiterTodayWorkPage() {
  const userId = getDecryptedData('Id');

  return (
    <PageShell
      title="Today's Work"
      subtitle="Profiles you submitted and requirements you worked on."
      breadcrumbs={[
        { label: 'Dashboard', path: '/dashboard' },
        { label: "Today's Work" },
      ]}
      backTo="/dashboard"
    >
      <RecruiterTodayWork userId={userId} showTitle={false} />
    </PageShell>
  );
}

export default RecruiterTodayWorkPage;
